/*---------------------------------------------------------------------------------------------
 * Copyright (c) Bentley Systems, Incorporated. All rights reserved.
 * See LICENSE.md in the project root for license terms and full copyright notice.
 *--------------------------------------------------------------------------------------------*/
import React from 'react';
import { useTheme } from '../utils';
/**
 * Component providing global styles that are required for all components and allows changing theme.
 */
export var ThemeProvider = function (props) {
    var theme = props.theme, children = props.children, themeOptions = props.themeOptions;
    useTheme(theme, themeOptions);
    return React.createElement(React.Fragment, null, children);
};
export default ThemeProvider;
